export default __webpack_public_path__ + "static/national-yards-desktop-0d6dd077bc56053a216481c0aededf40.svg";